// Cantons suisses — brique unique + testée. Utilisé pour filtrer les listes
// déroulantes (campagnes, contacts) afin d'ÉCARTER les départements français
// (Côte-d'Or, Doubs, Bas-Rhin…) qui traînent parfois dans la donnée importée.

/** Les 26 codes officiels de canton suisse (2 lettres). */
export const SWISS_CANTONS = new Set([
  'AG', 'AI', 'AR', 'BE', 'BL', 'BS', 'FR', 'GE', 'GL', 'GR', 'JU', 'LU', 'NE',
  'NW', 'OW', 'SG', 'SH', 'SO', 'SZ', 'TG', 'TI', 'UR', 'VD', 'VS', 'ZG', 'ZH',
]);

/** true si `v` est un code de canton suisse (insensible à la casse). */
export function isSwissCanton(v) {
  return !!v && SWISS_CANTONS.has(String(v).trim().toUpperCase());
}

/** Liste triée et dédoublonnée des cantons SUISSES présents dans les contacts. */
export function swissCantons(contacts = []) {
  return [...new Set(contacts.map(c => c && c.canton).filter(Boolean))]
    .filter(isSwissCanton)
    .sort();
}
